module.exports = __webpack_public_path__ + "img/hr-brown-asterisk-08.839e6bd1.png";